import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	dashboard: {
		currentTab: "ordersList", // default
	},
	productsList: [
		{ id: "1", productName: "SHAWL - RIBBON PLAIN", mrp: 350 },
		{ id: "2", productName: "SHEET - LACE 2PC", mrp: 1200 },
	],
	colorsList: [
		{ id: "1", name: "Red" },
		{ id: "2", name: "Blue" },
		{ id: "3", name: "Green" },
	],
	orders: {
		assigningOrderObj: {},
	},
};

const GlobalSelectsSlice = createSlice({
	name: "globalSelectsSlice",
	initialState,
	reducers: {
		setDashboardCurrentTab: (state, action) => {
			state.dashboard.currentTab = action.payload;
		},
		setProductsListGlobally: (state, action) => {
			state.productsList = action.payload;
		},
		setColorsListGlobally: (state, action) => {
			state.colorsList = action.payload;
		},
		setAssigningOrder: (state, action) => {
			state.orders.assigningOrderObj = action.payload;
		},
	},
});

export const {
	setDashboardCurrentTab,
	setProductsListGlobally,
	setColorsListGlobally,
	setAssigningOrder,
} = GlobalSelectsSlice.actions;
export default GlobalSelectsSlice.reducer;
